import {
  Grid,
  TextField,
  TableCell,
  Table,
  TableBody,
  TableRow
} from '@material-ui/core';
import React, { Component } from 'react';
import PageHeader from '../common/PageHeader';
import { apiBatchRequest, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import _ from 'lodash';
import Reports from './Reports';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
// import 'jspdf-autotable';
import './report.less';
import moment from 'moment';
import { DateFormat } from '../../constants/appConstants';
import ReportButtons from './ReportButtons';
import AdvancedFilter from './AdvancedFilter';
import {
  GenerateAbsoluteURL,
  getCurrentPayCycleEndDateByDate,
  getCurrentPayCycleStartDateByDate,
  removeDuplicates,
  IsSensitiveDataAccess,
  EnhancedTableHead,
  orderBy,
  getPreviousPayCycle,
  cloneDeep,
  IsAutoRunPagesEnabled
} from '../../utils/helper';
import { getFormattedValues, getFormattedValuesForReport } from '../../utils/formatData';
import { getMultilevelGroupedData } from '../../utils/generic';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { extendibleMarketArray2 } from '../../constants/MockData';
import TableWithPaginations from './TableWithPaginations';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage'

const rowrender = { count: 0 };

const headCells = [
  {
    id: 'allocationRate',
    numeric: false,
    disablePadding: true,
    label: 'Allocation Percent',
    type: 'Number',
    format: 'Number',
    isSort: false,
    hideColumn: true
  },
  {
    id: 'burdenRatePercent',
    numeric: false,
    disablePadding: true,
    label: 'Burden Rate Percent',
    type: 'Number',
    format: 'Number',
    isSort: false,
    hideColumn: true
  },
  {
    id: 'propertyBillingPercent',
    numeric: false,
    disablePadding: true,
    label: 'Billing Percent',
    type: 'Number',
    format: 'Number',
    isSort: false,
    hideColumn: true
  },
  {
    id: 'flatrate',
    numeric: false,
    disablePadding: true,
    label: 'Flat Rate',
    type: 'Number',
    format: 'Number',
    isSort: false
  },
  {
    id: 'expenseAmount',
    numeric: false,
    disablePadding: true,
    label: 'Expense Amount',
    type: 'Number',
    format: 'Number',
    isSort: false
  },
  {
    id: 'burdenAmount',
    numeric: false,
    disablePadding: true,
    label: 'Burden Amount',
    type: 'Number',
    format: 'Number',
    isSort: false
  },
  {
    id: 'reimbursementCost',
    numeric: false,
    disablePadding: true,
    label: 'Reimbursement Cost',
    type: 'Number',
    format: 'Number',
    isSort: false
  }
];

export default class DatacenterPropertyReimbursementReport extends Component {
  constructor (props) {
    super(props);
    this.state = {
      showMain: false,
      propertyTypeMasterData: [],
      serviceTypeMasterData: [],
      employeeMasterData: [],
      propertyMasterData: [],
      marketMasterData: [],
      pmaTitleMasterData: [],
      legalEntityMasterData: [],
      expenseNameMasterData: [],
      accountCodeNameMasterData: [],
      payPeriodStartDate: moment().startOf('month').format(DateFormat),
      payPeriodEndDate: moment().endOf('month').format(DateFormat),
      propertyReimburseData: [],
      rows: [],
      showReport: false,
      clientListingMasterData: [],
      market: [{ marketName: 'All' }],
      pmaTitle: [{ pmaTitle: 'All' }],
      property: [{ propertyName: 'All' }],
      propertyType: [{ propertyTypeName: 'All' }],
      service: [{ serviceType: 'All' }],
      department: [{ departmentName: 'All' }],
      employee: [{ employeeName: 'All' }],
      client: [{ clientName: 'All' }],
      legalEntity: [{ customerName: 'All' }],
      expenseName: [{ expenseName: 'All' }],
      accountCode: [{ accountCode: 'All' }],
      openSlidingPanel: false,
      printPage: false,
      payPeriod: [],
      advanceFilterConfig: {
        groupBy: {
          masterData: [
            {
              key: 'Client',
              value: 'client',
              id: 'client',
              ssrsReport: 'Client',
              numeric: false,
              disablePadding: false,
              label: 'Client',
              type: 'Text',
              order: 2
            },
            {
              key: 'Legal Entity',
              id: 'legalEntity',
              value: 'legalEntity',
              ssrsReport: 'LegalEntity',
              numeric: false,
              disablePadding: false,
              label: 'Legal Entity',
              type: 'Text',
              order: 3
            },
            {
              key: 'Service Type',
              value: 'serviceType',
              id: 'serviceType',
              ssrsReport: 'ServiceType',
              numeric: false,
              disablePadding: false,
              label: 'Service Type',
              type: 'Text',
              order: 4
            },
            {
              key: 'Property Name',
              value: 'propertyName',
              id: 'propertyName',
              ssrsReport: 'PropertyName',
              numeric: false,
              disablePadding: false,
              label: 'Client',
              type: 'Text',
              order: 5
            },
            {
              key: 'Property Type',
              value: 'propertyType',
              id: 'propertyType',
              ssrsReport: 'PropertyType',
              numeric: false,
              disablePadding: false,
              label: 'Property Type',
              type: 'Text',
              order: 6
            },
            {
              key: 'Account Code Name',
              value: 'accountCode',
              id: 'accountCode',
              ssrsReport: 'AccountCode',
              numeric: false,
              disablePadding: false,
              label: 'Account Code Name',
              type: 'Text',
              order: 7
            },
            {
              key: 'Employee',
              value: 'employeeName',
              id: 'employeeName',
              ssrsReport: 'EmployeeName',
              numeric: false,
              disablePadding: false,
              label: 'Employee',
              type: 'Text',
              order: 8
            },
            {
              key: 'PMA Title',
              value: 'pmaTitle',
              id: 'pmaTitle',
              ssrsReport: 'PmaTitle',
              numeric: false,
              disablePadding: false,
              label: 'PMA Title',
              type: 'Text',
              order: 9
            },
            {
              key: 'Expense Name',
              value: 'expenseName',
              id: 'expenseName',
              ssrsReport: 'ExpenseName',
              numeric: false,
              disablePadding: false,
              label: 'Expense Name',
              type: 'Text',
              order: 10
            }, {
              key: 'Reimbursement Type',
              value: 'reimbursementType',
              id: 'reimbursementType',
              ssrsReport: 'ReimbursementType',
              numeric: false,
              disablePadding: false,
              label: 'Reimbursement Type',
              type: 'Text',
              order: 11
            }],
          selected: [{
            key: 'Market',
            value: 'marketName',
            id: 'marketName',
            ssrsReport: 'MarketName',
            numeric: false,
            disablePadding: false,
            label: 'Market',
            type: 'Text',
            order: 1
          }]
        },
        selectedDate: {},
        suppressGraph: false,
        suppressZero: true,
        summaryRows: true,
        suppressDetails: false,
        showZeroNGraph: true,
        startDate: getPreviousPayCycle().previousPayCycleStartDate,
        endDate: getPreviousPayCycle().previousPayCycleEndDate
      },
      summaryCols: ['reimbursementCost'],
      expand: false,
      handleCollapse: false,
      order: 'asc',
      orderBy: 'nam',
      supervisorEmployee: [{ employeeName: 'All' }],
      supervisorEmployeeMasterData: [],
      isAutoRunEnabled: IsAutoRunPagesEnabled(),
      isSubmitButtonClicked: false
    };

    this.baseState = this.state;
  }

  componentDidMount () {
    window.scrollTo(0, 0);
    this.loadData();
  }

    goBack = () => {
      this.setState({
        showMain: true
      });
    };

    handleClickOpen = () => {
      this.setState({
        openSlidingPanel: true
      });
    };

    handleDateChange = (date, name) => {
      this.setState({
        [name]: moment(date).format(DateFormat)
      });
    };

    handleClose = () => {
      this.setState({
        openSlidingPanel: false
      });
    };

    resetPage = () => {
      const { advanceFilterConfig } = this.state;
      advanceFilterConfig.summaryRows = true;
      advanceFilterConfig.suppressZero = true;
      advanceFilterConfig.suppressDetails = false;
      advanceFilterConfig.groupBy = {
        masterData: [
          {
            key: 'Client',
            value: 'client',
            id: 'client',
            ssrsReport: 'Client',
            numeric: false,
            disablePadding: false,
            label: 'Client',
            type: 'Text',
            order: 2
          },
          {
            key: 'Legal Entity',
            id: 'legalEntity',
            value: 'legalEntity',
            ssrsReport: 'LegalEntity',
            numeric: false,
            disablePadding: false,
            label: 'Legal Entity',
            type: 'Text',
            order: 3
          },
          {
            key: 'Service Type',
            value: 'serviceType',
            id: 'serviceType',
            ssrsReport: 'ServiceType',
            numeric: false,
            disablePadding: false,
            label: 'Service Type',
            type: 'Text',
            order: 4
          },
          {
            key: 'Property Name',
            value: 'propertyName',
            id: 'propertyName',
            ssrsReport: 'PropertyName',
            numeric: false,
            disablePadding: false,
            label: 'Client',
            type: 'Text',
            order: 5
          },
          {
            key: 'Property Type',
            value: 'propertyType',
            id: 'propertyType',
            ssrsReport: 'PropertyType',
            numeric: false,
            disablePadding: false,
            label: 'Property Type',
            type: 'Text',
            order: 6
          },
          {
            key: 'Account Code Name',
            value: 'accountCode',
            id: 'accountCode',
            ssrsReport: 'AccountCode',
            numeric: false,
            disablePadding: false,
            label: 'Account Code Name',
            type: 'Text',
            order: 7
          },
          {
            key: 'Employee',
            value: 'employeeName',
            id: 'employeeName',
            ssrsReport: 'EmployeeName',
            numeric: false,
            disablePadding: false,
            label: 'Employee',
            type: 'Text',
            order: 8
          },
          {
            key: 'PMA Title',
            value: 'pmaTitle',
            id: 'pmaTitle',
            ssrsReport: 'PmaTitle',
            numeric: false,
            disablePadding: false,
            label: 'PMA Title',
            type: 'Text',
            order: 9
          },
          {
            key: 'Expense Name',
            value: 'expenseName',
            id: 'expenseName',
            ssrsReport: 'ExpenseName',
            numeric: false,
            disablePadding: false,
            label: 'Expense Name',
            type: 'Text',
            order: 10
          }, {
            key: 'Reimbursement Type',
            value: 'reimbursementType',
            id: 'reimbursementType',
            ssrsReport: 'ReimbursementType',
            numeric: false,
            disablePadding: false,
            label: 'Reimbursement Type',
            type: 'Text',
            order: 11
          }],
        selected: [{
          key: 'Market',
          value: 'marketName',
          id: 'marketName',
          ssrsReport: 'MarketName',
          numeric: false,
          disablePadding: false,
          label: 'Market',
          type: 'Text',
          order: 1
        }]

      };
      this.setState({
        ...this.baseState,
        isSubmitButtonClicked: false,
        showReport: this.state.isAutoRunEnabled ? true : false,
        advanceFilterConfig
      }, () => {
        this.loadData();
      });      
    };

    handlePrintClick = () => {
      this.handleExport('application/pdf', 'Pdf', true);
    };

    GetPropertyReimburseData = () => {
      const {
        market,
        property,
        propertyType,
        service,
        employee,
        client,
        legalEntity,
        payPeriodStartDate,
        payPeriodEndDate,
        expenseName,
        accountCode,
        pmaTitle,
        supervisorEmployee
      } = this.state;
      const marketId = _.cloneDeep(market.map((x) => x.marketId));
      const propertyId = _.cloneDeep(property.map((x) => x.propertyId));
      const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));
      const clientId = _.cloneDeep(client.map((x) => x.clientId));
      const legalEntityId = _.cloneDeep(legalEntity.map((x) => x.customerId));
      const propertyTypeId = _.cloneDeep(
        propertyType.map((x) => x.propertyTypeId)
      );
      const serviceTypeId = _.cloneDeep(service.map((x) => x.serviceTypeId));
      const expenseNameId = _.cloneDeep(expenseName.map((x) => x.expenseNameId));
      const accountCodeId = _.cloneDeep(accountCode.map((x) => x.accountCodeId));
      const pmaTitleId = _.cloneDeep(pmaTitle.map((x) => x.pmaTitleId));
      const supervisorId = _.cloneDeep(supervisorEmployee.map((x) => x.ultiProEmployeeId));

      const fromDate =
        payPeriodStartDate == null
          ? getCurrentPayCycleStartDateByDate(moment())
          : payPeriodStartDate;
      const toDate =
        payPeriodEndDate == null
          ? getCurrentPayCycleEndDateByDate(moment())
          : payPeriodEndDate;

      const params = {
        payPeriodStartDate: moment(fromDate).format(DateFormat),
        payPeriodEndDate: moment(toDate).format(DateFormat),
        marketId: marketId.join('|'),
        propertyId: propertyId.join('|'),
        propertyTypeId: propertyTypeId.join('|'),
        serviceTypeId: serviceTypeId.join('|'),
        employeeId: employeeId.join('|'),
        clientId: clientId.join('|'),
        legalEntityId: legalEntityId.join('|'),
        expenseNameId: expenseNameId.join('|'),
        accountCodeId: accountCodeId.join('|'),
        pmaTitleId: pmaTitleId.join('|'),
        supervisorId: supervisorId.join('|')
      };
      this._asyncRequest = apiBatchRequest([
        {
          url: API_URL.Report.GetDataCenterPropertyReimbursement,
          params,
          key: 'propertyReimburseData'
        }
      ])
        .then(({ propertyReimburseData }) => {
          this._asyncRequest = null;
          if (propertyReimburseData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          const propertyReimburseDataValue = propertyReimburseData.data || [];
          console.log(propertyReimburseDataValue);
          const rows = this.getTableRow(propertyReimburseDataValue);
          this.setState({
            propertyReimburseData: propertyReimburseDataValue,
            rows,
            originalPropertyReimbursementData: propertyReimburseDataValue,
            showReport: true,
            isSubmitButtonClicked: true,
            // payPeriod,
            expand: false

          });
        })
        .catch(() => {
          this._asyncRequest = null;
        });
    };

    renderTableCell = (groupedData, currentGroupedRow = [], tableCell = [], rowCount = 0) => {
      const showSummary = this.state.advanceFilterConfig.summaryRows;
      const suppressDetails = this.state.advanceFilterConfig.suppressDetails;
      const sequence = this.getColumnSequence();
      let column1 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[0]?.value) || {}).value ?? '' : '';
      let column2 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[1]?.value) || {}).value ?? '' : '';
      let column3 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[2]?.value) || {}).value ?? '' : '';
      let column4 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[3]?.value) || {}).value ?? '' : '';
      let column5 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[4]?.value) || {}).value ?? '' : '';
      let column6 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[5]?.value) || {}).value ?? '' : '';
      let column7 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[6]?.value) || {}).value ?? '' : '';
      let column8 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[7]?.value) || {}).value ?? '' : '';
      let column9 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[8]?.value) || {}).value ?? '' : '';
      let column10 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[9]?.value) || {}).value ?? '' : '';
      let column11 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[10]?.value) || {}).value ?? '' : '';

      groupedData.forEach((d, i) => {
        if (d.data !== undefined) {
          // rowCount = 0;
          currentGroupedRow = currentGroupedRow.filter(x => x.key !== d.key);
          currentGroupedRow.push({ key: d.key, value: d[d.key] });
          if (this.state.advanceFilterConfig.summaryRows === false) {
            this.renderTableCell(d.data, currentGroupedRow, tableCell, rowCount);
          }
        }
        const keyvalue = this.adjustColumnSequence(_.cloneDeep(currentGroupedRow));
        if (d.reimbursmentDetails) {
          const evenOddClass =
            tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
          const topBorderClass =
            column1 !== (keyvalue.find(x => x.key === sequence[0]?.value) || {}).value ?? '' ? ' rpt-topBorder ' : ' ';
          const key = rowCount + '_' + i;
          if (d.reimbursmentDetails.length > 0 && (d.reimbursmentDetails[0].isSummary === undefined ||
            (d.reimbursmentDetails.length > 0 && d.reimbursmentDetails[0].isSummary === true &&
              this.state.advanceFilterConfig.summaryRows === true))) {
            if ((suppressDetails && d.isGroup) || (!suppressDetails)) {
              tableCell.push(
                <TableRow
                  // key={key}
                  className={(this.state.advanceFilterConfig.summaryRows === true ? topBorderClass : '') + (d.isGroup === true ? ' parent-row' : '')}
                >{(!suppressDetails || (suppressDetails && sequence[0]?.value !== '')) && (
                  <TableCell
                    className={'st sticky ' + evenOddClass + (column1 !== d[sequence[0]?.value] &&
                      ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[0]?.value])
                      ? topBorderClass
                      : '')}
                  >
                    {getFormattedValues(column1 !== d[sequence[0]?.value] && d[sequence[0]?.value], 'Text')}{' '}
                  </TableCell>
                )
                  }
                  {(!suppressDetails || (suppressDetails && sequence[1]?.value !== undefined && sequence[1]?.value !== '')) && (
                    <TableCell
                      className={
                        'st sticky-1 ' +
                        evenOddClass +
                        (column2 !== d[sequence[1]?.value] &&
                          ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[1]?.value])
                          ? ' rpt-topBorder '
                          : ' ')
                      }
                    >
                      {d.isGroup === true && getFormattedValues(column2 !== d[sequence[1]?.value] && d[sequence[1]?.value], 'Text').props?.children?.toString() === '-'
                        ? <span className='total-count'>{this.getGroupedArray(d, sequence[1]?.value)}</span>
                        : (getFormattedValues(column2 !== d[sequence[1]?.value] && d[sequence[1]?.value], 'Text') === null ? <span className='total-count'>-</span> : getFormattedValues(column2 !== d[sequence[1]?.value] && d[sequence[1]?.value], 'Text'))}
                    </TableCell>
                  )
                  }
                  {(!suppressDetails || (suppressDetails && sequence[2]?.value !== undefined && sequence[2]?.value !== '')) && (
                    <TableCell
                      className={
                        'st sticky-2 ' +
                        evenOddClass +
                        (column3 !== d[sequence[2]?.value] &&
                          ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[2]?.value])
                          ? ' rpt-topBorder '
                          : ' ')
                      }
                    >
                      {d.isGroup === true && getFormattedValues(column3 !== d[sequence[2]?.value] && d[sequence[2]?.value], 'Text')?.props?.children?.toString() === '-'
                        ? <span className='total-count'>{this.getGroupedArray(d, sequence[2]?.value)}</span>
                        : getFormattedValues(column3 !== d[sequence[2]?.value] && d[sequence[2]?.value], 'Text')}
                    </TableCell>
                  )
                  }
                  {(!suppressDetails || (suppressDetails && sequence[3]?.value !== undefined && sequence[3]?.value !== '')) && (
                    <TableCell
                      className={
                        'st sticky-3 ' +
                        evenOddClass +
                        (column4 !== d[sequence[3]?.value] &&
                          ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[3]?.value])
                          ? ' rpt-topBorder '
                          : ' ')
                      }
                    >
                      {d.isGroup === true && getFormattedValues(column4 !== d[sequence[3]?.value] && d[sequence[3]?.value], 'Text').props?.children?.toString() === '-'
                        ? <span className='total-count'>{this.getGroupedArray(d, sequence[3]?.value)}</span>
                        : getFormattedValues(column4 !== d[sequence[3]?.value] && d[sequence[3]?.value], 'Text')}
                    </TableCell>
                  )
                  }
                  {(!suppressDetails || (suppressDetails && sequence[4]?.value !== undefined && sequence[4]?.value !== '')) && (
                    <TableCell
                      className={
                        'st sticky-4 ' +
                        evenOddClass +
                        (column5 !== d[sequence[4]?.value] &&
                          ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[4]?.value])
                          ? ' rpt-topBorder '
                          : ' ')
                      }
                    >
                      {d.isGroup === true && getFormattedValues(column5 !== d[sequence[4]?.value] && d[sequence[4]?.value], 'Text').props?.children?.toString() === '-'
                        ? <span className='total-count'>{this.getGroupedArray(d, sequence[4]?.value)}</span>
                        : getFormattedValues(column5 !== d[sequence[4]?.value] && d[sequence[4]?.value], 'Text')}
                    </TableCell>
                  )
                  }
                  {(!suppressDetails || (suppressDetails && sequence[5]?.value !== undefined && sequence[5]?.value !== '')) && (
                    <TableCell
                      className={
                        'st sticky-5 ' +
                        evenOddClass +
                        (column6 !== d[sequence[5]?.value] &&
                          ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[5]?.value])
                          ? ' rpt-topBorder '
                          : ' ')
                      }
                    >
                      {d.isGroup === true && getFormattedValues(column6 !== d[sequence[5]?.value] && d[sequence[5]?.value], 'Text').props?.children?.toString() === '-'
                        ? <span className='total-count'>{this.getGroupedArray(d, sequence[5]?.value)}</span>
                        : getFormattedValues(column6 !== d[sequence[5]?.value] && d[sequence[5]?.value], 'Text')}
                    </TableCell>
                  )
                  }
                  {(!suppressDetails || (suppressDetails && sequence[6]?.value !== undefined && sequence[6]?.value !== '')) && (
                    <TableCell
                      className={
                        'st sticky-6 ' +
                        evenOddClass +
                        (column7 !== d[sequence[6]?.value] &&
                          ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[6]?.value])
                          ? ' rpt-topBorder '
                          : ' ')
                      }
                    >
                      {d.isGroup === true && getFormattedValues(column7 !== d[sequence[6]?.value] && d[sequence[6]?.value], 'Text').props?.children?.toString() === '-'
                        ? <span className='total-count'>{this.getGroupedArray(d, sequence[6]?.value)}</span>
                        : getFormattedValues(column7 !== d[sequence[6]?.value] && d[sequence[6]?.value], 'Text')}
                    </TableCell>
                  )
                  }
                  {(!suppressDetails || (suppressDetails && sequence[7]?.value !== undefined && sequence[7]?.value !== '')) && (
                    <TableCell
                      className={
                        'st sticky-7 ' +
                        evenOddClass +
                        (column8 !== d[sequence[7]?.value] &&
                          ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[7]?.value])
                          ? ' rpt-topBorder '
                          : ' ')
                      }
                    >
                      {d.isGroup === true && getFormattedValues(column8 !== d[sequence[7]?.value] && d[sequence[7]?.value], 'Text').props?.children?.toString() === '-'
                        ? <span className='total-count'>{this.getGroupedArray(d, sequence[7]?.value)}</span>
                        : getFormattedValues(column8 !== d[sequence[7]?.value] && d[sequence[7]?.value], 'Text')}
                    </TableCell>
                  )
                  }
                  {(!suppressDetails || (suppressDetails && sequence[8]?.value !== undefined && sequence[8]?.value !== '')) && (
                    <TableCell
                      className={
                        'st sticky-8 ' +
                        evenOddClass +
                        (column9 !== d[sequence[8]?.value] &&
                          ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[8]?.value])
                          ? ' rpt-topBorder '
                          : ' ')
                      }
                    >
                      {d.isGroup === true && getFormattedValues(column9 !== d[sequence[8]?.value] && d[sequence[8]?.value], 'Text').props?.children?.toString() === '-'
                        ? <span className='total-count'>{this.getGroupedArray(d, sequence[8]?.value)}</span>
                        : getFormattedValues(column9 !== d[sequence[8]?.value] && d[sequence[8]?.value], 'Text')}
                    </TableCell>
                  )
                  }
                  {(!suppressDetails || (suppressDetails && sequence[9]?.value !== undefined && sequence[9]?.value !== '')) && (
                    <TableCell
                      className={
                        'st sticky-9 ' +
                        evenOddClass +
                        (column10 !== d[sequence[9]?.value] &&
                          ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[9]?.value])
                          ? ' rpt-topBorder '
                          : ' ')
                      }
                    >
                      {d.isGroup === true && getFormattedValues(column10 !== d[sequence[9]?.value] && d[sequence[9]?.value], 'Text').props?.children?.toString() === '-'
                        ? <span className='total-count'>{this.getGroupedArray(d, sequence[9]?.value)}</span>
                        : getFormattedValues(column10 !== d[sequence[9]?.value] && d[sequence[9]?.value], 'Text')}
                    </TableCell>
                  )
                  }
                  {(!suppressDetails || (suppressDetails && sequence[10]?.value !== undefined && sequence[10]?.value !== '')) && (
                    <TableCell
                      className={
                        'st sticky-10 ' +
                        evenOddClass +
                        (column11 !== d[sequence[10]?.value] &&
                          ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[10]?.value])
                          ? ' rpt-topBorder '
                          : ' ')
                      }
                    >
                      {d.isGroup === true && getFormattedValues(column11 !== d[sequence[10]?.value] && d[sequence[10]?.value], 'Text').props?.children?.toString() === '-'
                        ? <span className='total-count'>{this.getGroupedArray(d, sequence[10]?.value)}</span>
                        : getFormattedValues(column11 !== d[sequence[10]?.value] && d[sequence[10]?.value], 'Text')}
                    </TableCell>
                  )
                  }
                  {this.renderReimbursementColumn(d.reimbursmentDetails, evenOddClass, key, d)}
                </TableRow>
              );
            }
          }
          rowCount++;
          rowrender.count++;
          column1 = (keyvalue.find(x => x.key === sequence[0]?.value) || {}).value ?? '';
          column2 = (keyvalue.find(x => x.key === sequence[1]?.value) || {}).value ?? '';
          column3 = (keyvalue.find(x => x.key === sequence[2]?.value) || {}).value ?? '';
          column4 = (keyvalue.find(x => x.key === sequence[3]?.value) || {}).value ?? '';
          column5 = (keyvalue.find(x => x.key === sequence[4]?.value) || {}).value ?? '';
          column6 = (keyvalue.find(x => x.key === sequence[5]?.value) || {}).value ?? '';
          column7 = (keyvalue.find(x => x.key === sequence[6]?.value) || {}).value ?? '';
          column8 = (keyvalue.find(x => x.key === sequence[7]?.value) || {}).value ?? '';
          column9 = (keyvalue.find(x => x.key === sequence[8]?.value) || {}).value ?? '';
          column10 = (keyvalue.find(x => x.key === sequence[9]?.value) || {}).value ?? '';
          column11 = (keyvalue.find(x => x.key === sequence[10]?.value) || {}).value ?? '';
        }
        if (d.data !== undefined && this.state.advanceFilterConfig.summaryRows === true && d.isGroup === true) {
          this.renderTableCell(d.data, currentGroupedRow, tableCell, rowCount);
        }
      });
      return tableCell;
    };

    renderReimbursementColumn = (reimbursementDetails, evenOddClass, key, d) => {
      const tableCell = [];
      tableCell.push(<>
        {
              extendibleMarketArray2.map((obj, i) => (
                <TableCell className={(evenOddClass + 'rpt-topBorder')} key={obj.key + i}>
                  {
                    reimbursementDetails.map((reimburse, ind) =>
                      <div
                        key={obj.key + i + ind + key} className={((reimbursementDetails.length) > 1 && ind !== (reimbursementDetails.length - 1))
                          ? 'multi-pay-period'
                          : ''}>
                        {d.isGroup === true && obj.format === 'DecimalPercent' && reimburse[obj.key] === undefined
                          ? <span className='total-count'>{this.getGroupedArray(reimburse, reimburse[obj.key])}</span>
                          : reimburse[obj.key] === null
                            ? <span className="number-text">-</span>
                            : getFormattedValuesForReport(reimburse[obj.key], obj.format, obj.appendText)}
                      </div>

                    )
                  }
                </TableCell>
              ))
            }
      </>);
      return tableCell;
    }

    renderTableRow = (data) => {
      if (this.state.advanceFilterConfig.suppressZero === true) {
        data = data.filter(x => {
          return _.chain(x.reimbursmentDetails).sumBy(x => x.reimbursementCost).value() !== 0;
        });
      }
      if (this?.state?.advanceFilterConfig?.showSummary !== true) {
        data = _.chain(data).orderBy(this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value), 'asc').value();
      }
      return this.renderTableCell(
        getMultilevelGroupedData(data, this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value), true),
        []);
    };

    getTableRow = (propertyReimburseData) => {
      let returnRows = [];

      returnRows = [...returnRows, ...this.renderTableRow(
        orderBy(propertyReimburseData, this.state.orderBy, this.state.order)
      )];
      return returnRows;
    }

    handleRequestSort = (event, property) => {
      const isAsc = this.state.orderBy === property && this.state.order === 'asc';
      let rows = [];
      rows = [...rows, ...this.renderTableRow(
        orderBy((this.state.propertyReimburseData || []), property, isAsc ? 'desc' : 'asc')
      )];
      this.setState({
        order: isAsc ? 'desc' : 'asc',
        orderBy: property,
        rows
      }, () => { this.forceUpdate(); });
    };

    renderTable = (rows) => {
      const { propertyReimburseData } = this.state;
      const groupSequence = this.getColumnSequence();

      return (
        <Table className="reportTable" id="rptTable" key="rptTable">
         <EnhancedTableHead
          order={this.state.order}
          orderBy={this.state.orderBy}
          onRequestSort={this.handleRequestSort}
          rowCount={propertyReimburseData.length}
          columnSequence={groupSequence}
          headCells={headCells}
          suppressDetails = {this.state.advanceFilterConfig.suppressDetails}
        />

          <TableBody>{rows}</TableBody>
        </Table>
      );
    };

    handleChange = (e, value, name, optionLabel) => {
      if (name !== null) {
        if ((this.state[name] || []).find(x => x[optionLabel] === 'All') === undefined) {
          if (value && value.length === 0) {
            value = [{ [optionLabel]: 'All' }];
            this.setState({ [name]: value });
          } else if ((value || []).find(x => x[optionLabel] === 'All')) {
            this.setState({ [name]: [{ [optionLabel]: 'All' }] });
          } else {
            this.setState({ [name]: value });
          }
        } else {
          value = (value || []).filter(x => x[optionLabel] !== 'All');
          if (value && value.length === 0) {
            value = [{ [optionLabel]: 'All' }];
          }
          this.setState({ [name]: value });
        }
      } else {
        this.setState({ [name]: e.target.value });
      }
    };

    getColumnSequence = () => {
      if (this.state.advanceFilterConfig.suppressDetails) {
        return removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected], 'key');
      } else {
        return removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected, ...this.state.advanceFilterConfig.groupBy.masterData], 'key');
      }
    }

    adjustColumnSequence = (currentGroupedRow) => {
      this.state.advanceFilterConfig.groupBy.masterData.forEach(x => {
        currentGroupedRow.push({ key: x.value });
      }
      );
      return currentGroupedRow;
    }

    onAddvanceFilterChange = (advanceFilterConfig) => {
      this.setState({
        advanceFilterConfig: advanceFilterConfig,
        openSlidingPanel: false
      }, () => this.GetPropertyReimburseData());
    }

    getGroupedArray (d, key) {
      return '';
    }

    handleExport = (fileMimeType, type, isPrint) => {
      this.downloadFile(fileMimeType, type, isPrint);
    }

    downloadFile = (fileMimeType, type, isPrint) => {
      const {
        market,
        property,
        propertyType,
        service,
        client,
        legalEntity,
        payPeriodStartDate,
        payPeriodEndDate,
        advanceFilterConfig,
        employee,
        expenseName,
        accountCode,
        pmaTitle,
        supervisorEmployee
      } = this.state;
      const dataValue = [
        { key: 'AsOfDate', value: moment(payPeriodStartDate).format(DateFormat) }];
      const marketId = _.cloneDeep(market.map((x) => x.marketId));
      const pmaTitleId = _.cloneDeep(pmaTitle.map((x) => x.pmaTitleId));
      const serviceTypeId = _.cloneDeep(service.map((x) => x.serviceTypeId));
      const clientId = _.cloneDeep(client.map((x) => x.clientId));
      const legalEntityId = _.cloneDeep(legalEntity.map((x) => x.customerId));
      const propertyId = _.cloneDeep(property.map((x) => x.propertyId));
      const propertyTypeId = _.cloneDeep(propertyType.map((x) => x.propertyTypeId));
      const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));
      const expenseNameId = _.cloneDeep(expenseName.map((x) => x.expenseNameId));
      const accountCodeId = _.cloneDeep(accountCode.map((x) => x.accountCodeId));
      const supervisorId = _.cloneDeep(supervisorEmployee.map((x) => x.ultiProEmployeeId));

      dataValue.push({ key: 'MarketId', value: (marketId.join('|') === undefined || marketId.join('|') === '') ? '0' : marketId.join('|') });
      dataValue.push({ key: 'ServiceTypeId', value: (serviceTypeId.join('|') === undefined || serviceTypeId.join('|') === '') ? '0' : serviceTypeId.join('|') });
      dataValue.push({ key: 'ClientId', value: (clientId.join('|') === undefined || clientId.join('|') === '') ? '0' : clientId.join('|') });
      dataValue.push({ key: 'LegalentityId', value: (legalEntityId.join('|') === undefined || legalEntityId.join('|') === '') ? '0' : legalEntityId.join('|') });
      dataValue.push({ key: 'PropertyId', value: (propertyId.join('|') === undefined || propertyId.join('|') === '') ? '0' : propertyId.join('|') });
      dataValue.push({ key: 'PropertyTypeId', value: (propertyTypeId.join('|') === undefined || propertyTypeId.join('|') === '') ? '0' : propertyTypeId.join('|') });
      dataValue.push({ key: 'EmployeeId', value: (employeeId.join('|') === undefined || employeeId.join('|') === '') ? '0' : employeeId.join('|') });
      dataValue.push({ key: 'ExpenseNameId', value: (expenseNameId.join('|') === undefined || expenseNameId.join('|') === '') ? '0' : expenseNameId.join('|') });
      dataValue.push({ key: 'AccountCodeId', value: (accountCodeId.join('|') === undefined || accountCodeId.join('|') === '') ? '0' : accountCodeId.join('|') });
      dataValue.push({ key: 'PmaTitleId', value: (pmaTitleId.join('|') === undefined || pmaTitleId.join('|') === '') ? '0' : pmaTitleId.join('|') });
      dataValue.push({ key: 'supervisorId', value: (supervisorId.join('|') === undefined || supervisorId.join('|') === '') ? '0' : supervisorId.join('|') });

      dataValue.push({ key: 'ShowSensitiveData', value: IsSensitiveDataAccess() });
      dataValue.push({ key: 'SuppressZero', value: advanceFilterConfig.suppressZero === true ? 1 : 0 });
      // dataValue.push({ key: 'SuppressDetail', value: advanceFilterConfig.suppressDetails === true ? 1 : 0 });
      // dataValue.push({ key: 'ShowSummaryRow', value: advanceFilterConfig.summaryRows === true ? 1 : 0 });
      let url = '';

      if (advanceFilterConfig.suppressDetails === true) {
        url = GenerateAbsoluteURL(dataValue, advanceFilterConfig.groupBy.selected, 'Data%20Center%20Property%20Reimbursement%20Summary%20Report', type);
      } else {
        dataValue.push({ key: 'ShowSummaryRow', value: advanceFilterConfig.summaryRows === true ? 1 : 0 });
        url = GenerateAbsoluteURL(dataValue, advanceFilterConfig.groupBy.selected, 'Data%20Center%20Property%20Reimbursement%20Report', type);
      }
      downloadReport(
        url,
        'Datacenter Property Reimbursement Report',
        fileMimeType,
        type,
        isPrint
      );
    }

    loadData () {
      this._asyncRequest = apiBatchRequest([
        {
          url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
          key: 'employeeMasterData'
        },
        {
          url: API_URL.Property.GetPropertyTypeMasterData + '?isDataCenterCall=true',
          key: 'propertyTypeMasterData',
          fromCache: true,
          duration: 15
        },
        {
          url: API_URL.Assignments.GetServiceTypeMasterData + '?isDataCenterCall=true',
          key: 'serviceTypeMasterData',
          fromCache: true,
          duration: 15
        },
        {
          url: API_URL.Property.GetPropertyMasterData + '?getSDCProperties=true',
          key: 'propertyMasterData'
        },
        {
          url: API_URL.Market.GetMarketMasterdata + '?isDataCenterCall=true',
          key: 'marketMasterData',
          fromCache: true,
          duration: 30
        },
        {
          url: API_URL.Users.GetPmaTitles + '?isDataCenterCall=true',
          key: 'pmaTitleMasterData',
          fromCache: true,
          duration: 60
        },
        {
          url: API_URL.Transition.GetClientListingData + '?isDataCenterCall=true',
          key: 'clientListingMasterData',
          fromCache: true,
          duration: 1
        },
        {
          url: API_URL.Transition.GetCustomerListingData + '?isDataCenterCall=true',
          key: 'legalEntityMasterData',
          fromCache: true,
          duration: 1
        },
        {
          url: API_URL.Report.GetExpenseName + '?isDataCenterCall=true',
          key: 'expenseNameMasterData'
        },
        {
          url: API_URL.Report.GetAccountCodeName + '?isDataCenterCall=true',
          key: 'accountCodeNameMasterData'
        }
      ])
        .then(
          ({
            employeeMasterData, propertyTypeMasterData, serviceTypeMasterData, propertyMasterData, marketMasterData, clientListingMasterData, legalEntityMasterData, expenseNameMasterData, accountCodeNameMasterData, pmaTitleMasterData
          }) => {
            this._asyncRequest = null;
            if (employeeMasterData.success !== true) {
              ShowToast(
                commonLabels.somethingWrong,
                toastType.ERROR,
                5000,
                500,
                'Server error'
              );
            }
            this.setState({
              supervisorEmployeeMasterData: cloneDeep(employeeMasterData.data || []),
              employeeMasterData: cloneDeep(employeeMasterData.data.filter(x => (x.marketId === 6 || x.marketId === 7 ||
                ((x.otherMarketId || '').split('|').indexOf((6 || '').toString()) !== -1) ||
                ((x.otherMarketId || '').split('|').indexOf((7 || '').toString()) !== -1))) || []),
              propertyTypeMasterData: propertyTypeMasterData.data,
              serviceTypeMasterData: serviceTypeMasterData.data,
              propertyMasterData: propertyMasterData.data,
              marketMasterData: marketMasterData.data.filter(x => x.marketId === 6 || x.marketId === 7),
              clientListingMasterData: clientListingMasterData.data,
              legalEntityMasterData: legalEntityMasterData.data,
              expenseNameMasterData: expenseNameMasterData.data,
              accountCodeNameMasterData: accountCodeNameMasterData.data,
              pmaTitleMasterData: pmaTitleMasterData.data || []
            }, () => {
              if(this.state.isAutoRunEnabled || this.state.isSubmitButtonClicked) {
                this.GetPropertyReimburseData();
              }              
            });
          }
        )
        .catch(() => {
          this._asyncRequest = null;
        });
    }

    render () {
      const {
        showMain,
        employeeMasterData,
        propertyMasterData,
        serviceTypeMasterData,
        propertyTypeMasterData,
        marketMasterData,
        legalEntityMasterData,
        propertyReimburseData,
        rows,
        clientListingMasterData,
        expenseNameMasterData,
        accountCodeNameMasterData,
        showReport,
        openSlidingPanel,
        advanceFilterConfig,
        payPeriodStartDate,
        expand,
        handleCollapse,
        pmaTitleMasterData,
        supervisorEmployeeMasterData
      } = this.state;

      if (marketMasterData.find(x => x.marketName === 'All') === undefined) {
        marketMasterData.unshift({ marketName: 'All' });
      }
      if (pmaTitleMasterData.find(x => x.pmaTitle === 'All') === undefined) {
        pmaTitleMasterData.unshift({ pmaTitle: 'All' });
      }
      if (employeeMasterData.find(x => x.employeeName === 'All') === undefined) {
        employeeMasterData.unshift({ employeeName: 'All' });
      }
      if (propertyTypeMasterData.find(x => x.propertyTypeName === 'All') === undefined) {
        propertyTypeMasterData.unshift({ propertyTypeName: 'All' });
      }
      if (serviceTypeMasterData.find(x => x.serviceType === 'All') === undefined) {
        serviceTypeMasterData.unshift({ serviceType: 'All' });
      }
      if (clientListingMasterData.find(x => x.clientName === 'All') === undefined) {
        clientListingMasterData.unshift({ clientName: 'All' });
      }
      if (legalEntityMasterData.find(x => x.customerName === 'All') === undefined) {
        legalEntityMasterData.unshift({ customerName: 'All' });
      }
      if (expenseNameMasterData.find(x => x.expenseName === 'All') === undefined) {
        expenseNameMasterData.unshift({ expenseName: 'All' });
      }
      if (accountCodeNameMasterData.find(x => x.accountCode === 'All') === undefined) {
        accountCodeNameMasterData.unshift({ accountCode: 'All' });
      }
      if (supervisorEmployeeMasterData.find(x => x.employeeName === 'All') === undefined) {
        supervisorEmployeeMasterData.unshift({ employeeName: 'All' });
      }
      return (
        <>
          {showMain
            ? (
              <Reports />
              )
            : (
              <>
                <PageHeader
                  key={'Datacenter_Property_Reimbursement_Report'}
                  title={'Datacenter Property Reimbursement Report'}
                  style={{ marginLeft: '1rem' }}
                  actionsConfig={[
                    {
                      icon: (
                        <ArrowBackIcon
                          size="small"
                          className="back-button no-print"
                        />
                      ),
                      onClick: this.goBack,
                      title: 'Back to Report'
                    }
                  ]}
                >
                  Datacenter Property Reimbursement Report
              </PageHeader>
                <Grid container spacing={3} className="no-print row top-xs" style={{ marginLeft: '10px' }}>
                  <Grid item xs={12} lg={2}>
                    <Grid item xs={12}>
                      <Autocomplete
                        blurOnSelect
                        multiple
                        limitTags={1}
                        value={this.state.market}
                        onChange={(e, val) => this.handleChange(e, val, 'market', 'marketName')}
                        id="tags-standard"
                        options={removeDuplicates(marketMasterData, 'marketName')}
                        getOptionLabel={(option) => option.marketName}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Market"
                          // placeholder="Market"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        blurOnSelect
                        multiple
                        limitTags={1}
                        id="tags-standard"
                        value={this.state.property}
                        options={removeDuplicates(propertyMasterData, 'propertyName')}
                        onChange={(e, val) => this.handleChange(e, val, 'property', 'propertyName')}
                        getOptionLabel={(option) => option.propertyName}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Property Name"
                          // placeholder="Property Name"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        blurOnSelect
                        multiple
                        limitTags={1}
                        id="tags-standard"
                        value={this.state.expenseName}
                        options={removeDuplicates(expenseNameMasterData, 'expenseName')}
                        onChange={(e, val) => this.handleChange(e, val, 'expenseName', 'expenseName')}
                        getOptionLabel={(option) => option.expenseName}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Expense Name"
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} lg={2}>
                    <Grid item xs={12}>
                      <Autocomplete
                        multiple
                        blurOnSelect
                        limitTags={1}
                        id="tags-standard"
                        value={this.state.service}
                        options={removeDuplicates(serviceTypeMasterData, 'serviceType')}
                        getOptionLabel={(option) => option.serviceType}
                        onChange={(e, val) => this.handleChange(e, val, 'service', 'serviceType')}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Service Type"
                          // placeholder="Service Type"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        multiple
                        blurOnSelect
                        limitTags={1}
                        id="tags-standard"
                        value={this.state.propertyType}
                        options={removeDuplicates(propertyTypeMasterData, 'propertyTypeName')}
                        getOptionLabel={(option) => option.propertyTypeName}
                        onChange={(e, val) =>
                          this.handleChange(e, val, 'propertyType', 'propertyTypeName')
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Property Type"
                          // placeholder="Property Type"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        multiple
                        blurOnSelect
                        limitTags={1}
                        id="tags-standard"
                        value={this.state.accountCode}
                        options={removeDuplicates(accountCodeNameMasterData, 'accountCode')}
                        getOptionLabel={(option) => option.accountCode}
                        onChange={(e, val) =>
                          this.handleChange(e, val, 'accountCode', 'accountCode')
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Account Code Name"
                          // placeholder="Property Type"
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} lg={2}>
                    <Grid item xs={12}>
                      <Autocomplete
                        multiple
                        limitTags={1}
                        blurOnSelect
                        id="tags-standard"
                        value={this.state.client}
                        options={removeDuplicates(clientListingMasterData, 'clientName')}
                        getOptionLabel={(option) => option.clientName}
                        onChange={(e, val) => this.handleChange(e, val, 'client', 'clientName')}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Client"
                          // placeholder="Client"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        multiple
                        limitTags={1}
                        blurOnSelect
                        id="tags-standard"
                        value={this.state.employee}
                        options={removeDuplicates(employeeMasterData, 'employeeName')}
                        getOptionLabel={(option) => option.employeeName}
                        onChange={(e, val) => this.handleChange(e, val, 'employee', 'employeeName')}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Employee Name"
                          // placeholder="Employee Name"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} >
                    <Autocomplete
                      multiple
                      blurOnSelect
                      value={this.state.supervisorEmployee}
                      onChange={(e, val) => {
                        this.handleChange(e, val, 'supervisorEmployee', 'employeeName');
                      }
                      }
                      id="tags-standard"
                      options={removeDuplicates(supervisorEmployeeMasterData, 'employeeName')}
                      limitTags={1}
                      getOptionLabel={(option) => option.employeeName}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Supervisor Name"
                        />
                      )}
                    />
                  </Grid>
                  </Grid>
                  <Grid item xs={12} lg={2} style={{ marginBottom: '56px' }} >
                    <Grid item xs={12} >
                      <Autocomplete
                        multiple
                        limitTags={1}
                        blurOnSelect
                        id="tags-standard"
                        options={removeDuplicates(legalEntityMasterData, 'customerName')}
                        value={this.state.legalEntity}
                        getOptionLabel={(option) => option.customerName}
                        onChange={(e, val) =>
                          this.handleChange(e, val, 'legalEntity', 'customerName')
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Legal Entity"
                          // placeholder="Legal Entity"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        blurOnSelect
                        multiple
                        limitTags={1}
                        id="tags-standard"
                        value={this.state.pmaTitle}
                        options={removeDuplicates(pmaTitleMasterData, 'pmaTitle')}
                        onChange={(e, val) => this.handleChange(e, val, 'pmaTitle', 'pmaTitle')}
                        getOptionLabel={(option) => option.pmaTitle}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="PMA Title"
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} lg={2}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Grid container justify="space-around">
                        <KeyboardDatePicker
                          margin="normal"
                          id="date-picker-dialog"
                          label="Pay Period(From)"
                          views={['year', 'month']}
                          value={payPeriodStartDate}
                          name={'payPeriodStartDate'}
                          onChange={(e) =>
                            this.handleDateChange(e, 'payPeriodStartDate')
                          }
                          KeyboardButtonProps={{
                            'aria-label': 'change date'
                          }}
                          inputProps={{ readOnly: true }}

                        />
                      </Grid>
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <ReportButtons
                    resetPage={this.resetPage}
                    handleSubmit={this.GetPropertyReimburseData}
                    handleClickOpen={this.handleClickOpen}
                    handlePrintClick={this.handlePrintClick}
                    downloadFile={this.handleExport}
                    data={propertyReimburseData}
                  />
                </Grid>
                <div className="col-lg-3 buttons">
                  <div className="col-lg-12">
                    <AdvancedFilter
                      payPeriodStartDate={this.state.payPeriodStartDate}
                      payPeriodEndDate={this.state.payPeriodEndDate}
                      filterConfig={advanceFilterConfig}
                      onApplyFilter={this.onAddvanceFilterChange}
                      openSlidingPanel={openSlidingPanel}
                      handleClose={this.handleClose}
                    />
                  </div>
                </div>
                {showReport &&
                  propertyReimburseData !== null &&
                  propertyReimburseData.length > 0 && (
                    <TableWithPaginations
                      tableData={rows} // {propertyReimburseData}
                      renderTable={this.renderTable}
                      expand={expand}
                      order={this.state.order}
                      oBy={this.state.orderBy}
                      handleCollapse={handleCollapse}
                    />
                )}
                {(this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === false) && 
                  (propertyReimburseData === null || propertyReimburseData.length <= 0) && (
                    <PageLandingMessage/>
                  )
                }
                {showReport &&
                  (propertyReimburseData == null ||
                    propertyReimburseData.length <= 0) && (
                    <Grid container spacing={4}>
                      <Grid
                        container
                        direction="row-reverse"
                        justify="center"
                        alignItems="stretch"
                      >
                        <label className="item-big">No Data Available.</label>
                      </Grid>
                    </Grid>
                )}
              </>
              )}
        </>
      );
    }
}
// prop reimburse cost
